module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"show_more_terms":"Zobrazit více termínů"},"sk":{"show_more_terms":"Zobraziť viac termínov"},"en":{"show_more_terms":"Show more terms"}}')
  delete Component.options._Ctor
}
